import { render } from "./AddTagsModal.vue?vue&type=template&id=1fb36185&scoped=true"
import script from "./AddTagsModal.vue?vue&type=script&lang=js"
export * from "./AddTagsModal.vue?vue&type=script&lang=js"

import "./AddTagsModal.vue?vue&type=style&index=0&id=1fb36185&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1fb36185"]])

export default __exports__